import React from "react";
import Box from "@mui/material/Box";
import { DropzoneState } from "react-dropzone";
import { Button } from "@mui/material";

interface UploadButtonProps {
  uploadText: string;
  dropzone: DropzoneState;
}

const UploadButton: React.FC<UploadButtonProps> = ({
  uploadText,
  dropzone,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        "& ul": {
          listStyle: "none",
          padding: 0,
        },
      }}
    >
      <Box
        {...dropzone.getRootProps({ className: "dropzone" })}
        sx={{
          cursor: "pointer",
          textAlign: "center",
          mb: 2,
          color: "text.secondary",
          backgroundColor: "background.default",
        }}
      >
        <input {...dropzone.getInputProps()} />
        <Button
          variant="contained"
          color="warning"
          fullWidth
          sx={{ textTransform: "none", p: 2 }}
        >
          {uploadText}
        </Button>
      </Box>
    </Box>
  );
};

export default UploadButton;
